
const formatPrice = require('../../../common/utility/price-formatter');
const { appyDealsCheck, isAppyDealsBadge } = require('../../../common/utility/appyDealsCheck');
const $ = require('jquery');
const _ = require('lodash');
const atmAddToFavoriteMapper = require('../cards/detail/product/atm-mapper-add-to-favorite');
const atmRemoveFromFavoriteMapper = require('../cards/detail/product/atm-mapper-remove-from-favorite');
const { APPY_DEALS_PAGE_NAME, APPY_DEALS_PAGE_SOURCE_ID, APPY_DEALS_EVENT_DATA } = require('../../../common/utility/appyDealsCheck');

class ProductController {
    constructor(trolleyService, savedListsService, $rootScope, $scope, $stateParams, ShopPageStateService, $uibModal, AtmService, settingsService, currentUserService, bwsNotificationService, $timeout, collectionTimeService, storePickerService, breakpointsService, shopperService, searchService, badgeService, inMemoryStorage) {
        this.$onInit = function() {
            this.shopPageStateService = ShopPageStateService;
            this.trolleyService = trolleyService;
            this.savedListsService = savedListsService;
            this.breakpointsService = breakpointsService;
            this.shopper = shopperService;
            this.atm = AtmService;
            this.$stateParams = $stateParams;
            const formattedPrice = formatPrice(this.product.Price);
            this.$timeout = $timeout;
            this.isWatched = false;
            this.priceCents = formattedPrice.cents;
            this.priceDollars = formattedPrice.dollars;
            this.productBadge = null;
            this.currentUserService = currentUserService;
            this.storePickerService = storePickerService;
            this.bwsNotificationService = bwsNotificationService;
            this.searchService = searchService;
            this.badgeService = badgeService;
            this.inMemoryStorage = inMemoryStorage;
            this.isRemovingItem = false;
            const wasprice = formatPrice(this.product.WasPrice);
            this.wasPriceDollars = wasprice.dollars;
            this.wasPriceCents = wasprice.cents;
            this.showAppyDeals = false; // default value. Will bee overwrite late
            this.showSavings = false;
            this.showSuperSavers = false;
            this.isAppyDealProductListPage = false; // default value. Will bee overwrite late
            this.isHeartIconHovered = false;
            this.animateHeart = false;
            this.viewTrackerArray = [];

            if (this.product.CentreTag) {
                this.hasTag = !!this.product.CentreTag.TagContent;
            }

            this.isAddingToTrolley = false;
            this.showPriceInBadge = this.product.IsOnSpecial;
            this.showTagInBadge = this.hasTag;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$uibModal = $uibModal;
            this.isPopupOpen = false;
            this.backOrderCollectionTime = collectionTimeService.calculateBackorderPickupDate();
            this.toggleWatchList = _.debounce(function (stockcode) {
                this.isHeartIconHovered = false;
                if (this.product.IsWatched) {
                    this.removeItemFromWatchList(stockcode);
                } else {
                    this.triggerBeaconWishListEvent();
                    this.addToWatchList(stockcode);
                }
            }, 200);

            // check if product is in a restricted category
            if (this.product && this.product.ProductData && this.product.ProductData.categoryleafnodeid) {
                settingsService.getSettingValue('ProductRestrictions', 'CategoryIds').then((restrictedCategories) => {
                    this.isInRestrictedCategory = (_.intersection(restrictedCategories, this.product.ProductData.categoryleafnodeid.map(id => id.toString())).length > 0);
                });
            }

            if (this.product && this.product.Tags[0]) {
                this.productBadge = this.product.Tags[0];
            }

            if (this.productCollection) {
                const selectedProduct = _.find(this.productCollection.Products, { IsInTrolley: true });

                //If product is in trolley
                if (selectedProduct) {
                    this.product = selectedProduct;
                }
            }

            if (this.product) {
                const pageId = this.$stateParams.Id;
                const productSource = this.product.Source;
                // check current page url param ID or ProductGroup ID
                this.isAppyDealProductListPage = pageId === APPY_DEALS_PAGE_NAME || productSource === APPY_DEALS_PAGE_SOURCE_ID;
                this.showSuperSavers = this.showSuperSaversBadge();
                this.showSavings = this.showSavingsBadge();
            }
        };
    }

    getAppyDealsCrossSellTypeData() {
        let cardPosition;

        this.$scope.$emit('cardCtrl:getCardPosition', (position) => {
            cardPosition = position;
        });

        // cardPosition is zero index base
        const productPosition = cardPosition + 1;
        const productStockcode = this.product && this.product.Stockcode
            ? this.product.Stockcode
            : '';

        return {
            productStockcode,
            productPosition,
            crossSellType: `web:plp:appy deals:${productPosition}`
        };
    }

    setAppyDealsCrossSellTyp() {
        const crossSellTypeData = this.getAppyDealsCrossSellTypeData();
        this.$stateParams.crossSellType = crossSellTypeData.crossSellType;
        this.inMemoryStorage.setItem(APPY_DEALS_EVENT_DATA, crossSellTypeData);
    }

    setAppyDealAddToCartTracking() {
        const crossSellTypeData = this.getAppyDealsCrossSellTypeData();

        const eventData = {
            position: crossSellTypeData.productPosition
        };

        this.setAppyDealsCrossSellTyp();
        // add eventData and trolley-service will pick it up for tracking
        this.inMemoryStorage.setItem('addToCartEventData', eventData);
    }

    trackClicksSponsoredAds(opt = {}) {
        const {
            clickTracker,
            fetchData = true
        } = opt;

        const productTracker = clickTracker || this.product.ClickTracker;

        if (this.isAppyDealProductListPage && this.$scope.ctrl && this.$scope.ctrl.showAppyDeals) {
            this.setAppyDealsCrossSellTyp();
        }

        if (fetchData && productTracker) {
            fetch(productTracker);
        }
    }

    addToTrolley() {
        const LIST = 'List';

        let previousCrossSell;

        if (this.crossSellType) {
            previousCrossSell = this.$stateParams.crossSellType
                ? '' + this.$stateParams.crossSellType
                : null;
            this.$stateParams.crossSellType = this.crossSellType;
        }

        this.bwsNotificationService.clearAll();
        this.productStockOnHand = this.product.BackorderStockOnHand > (this.product.ProductData.maxpurchasequantity || this.product.SupplyLimit)
            ? (this.product.ProductData.maxpurchasequantity || this.product.SupplyLimit)
            : this.product.BackorderStockOnHand + this.product.StockOnHand;

        if (this.product.StockOnHand === 0) {
            this.bwsNotificationService.info(
                `This item is currently unavailable at ${this.storePickerService.store.FulfilmentStoreName
                }. Order now and pick up by ${this.backOrderCollectionTime}`);
        }

        if (!this.product.IsInTrolley) {
            this.product.IsInTrolley = true;
            const area = this.parentTitle || LIST;
            this.isAddingToTrolley = true;

            if (this.isAppyDealProductListPage && this.$scope.ctrl && this.$scope.ctrl.showAppyDeals) {
                this.setAppyDealAddToCartTracking();
            }

            this.trolleyService
                .addItemToTrolley(this.product, this.product.QuantityInTrolley + 1, area)
                .then(() => {
                    this.isAddingToTrolley = false;
                    this.$stateParams.crossSellType = previousCrossSell;
                });
        }
    }

    openCart() {
        this.shopPageStateService.triggerPanel('right', true, 'product tile overlay');
    }

    remove() {
        this.isRemovingItem = true;

        // Get Trolley Product from service to pass to analytics so we have Qty and Sale Price
        const trolleyProduct = _.find(this.trolleyService.trolleyProducts, (item) => {
            return item.Stockcode === this.product.Stockcode;
        });

        this.trolleyService
            .removeTrolleyItem(this.product.Stockcode, trolleyProduct, 'Product tile overlay')
            .then(() => {
                this.isRemovingItem = false;
            });
    }

    addToCart() {
        this.addToTrolley();
        this.trackClicksSponsoredAds();
        this.$scope.$emit('basketTracker:update', { product:this.product });
    }

    addToWatchList(stockcode) {

        this.savedListsService.addToList(stockcode, 1, this.product)
            .then((response) => {
                this.isWatched = true;
                this.product.IsWatched = true;
                this.$rootScope.$emit('watchlist:updated');
                const area = this.parentTitle || 'List';
                const atmData = { product: this.product, area, headers: response.headers };
                this.shopper.currentUser.numberOfItemsInWatchList++;

                if (this.inMemoryStorage.getItem('addToFavouritesEventData')) {
                    atmData.eventData = this.inMemoryStorage.getItem('addToFavouritesEventData');
                    this.inMemoryStorage.removeItem('addToFavouritesEventData');
                }

                this.atm.push(atmData, atmAddToFavoriteMapper);
            }, () => {
                this.$timeout(() => {
                    if (this.currentUserService.currentUser.isGuest) {
                        this.bwsNotificationService.info('You need to login or register to add to your favourites');
                    }
                }, 2000);
            });
    }

    removeItemFromWatchList(stockcode) {
        this.savedListsService.removeFromWatchList(stockcode)
            .then(() => {
                this.isWatched = false;
                this.product.IsWatched = false;
                this.savedListsService.getList().then(data => {
                    if (this.triggerOnWatch) {
                        this.triggerOnWatch()(this.product, data.Response[0].ProductsCount);
                    }
                    this.$rootScope.$emit('watchlist:updated');
                    this.shopper.currentUser.numberOfItemsInWatchList--;
                    const area = this.parentTitle || 'List';
                    const atmData = { product: this.product, area };
                    this.atm.push(atmData, atmRemoveFromFavoriteMapper);
                });
            });
    }

    showSuperSaversBadge() {
        return this.badgeService.showSuperSaversBadge(this.product);
    }

    showSavingsBadge() {
        if (this.showSuperSaversBadge()) return false;
        if (this.badgeService.isShelfTalkerTypeGreatValue(this.product)) return false;
        return (!this.product.HideWasSavedPrice && this.product.SavingsAmount > 0 && !this.isInRistrictedCategory)
            || this.product.PercentageOffTag.SavedAmount > 0 && this.product.PercentageOffTag.TagType !== 'None'
            || this.product.FixedPricePromoTag.SavedAmount > 0 && this.product.FixedPricePromoTag.TagType !== 'None';
    }

    showPercentageOffBadge() {
        return this.badgeService.showPercentageOffBadge(this.product);
    }

    triggerBeaconWishListEvent(){  
        if(this.$scope.enableCriteoSponsoredAds && this.product.WishlistTracker){
            if(navigator.sendBeacon){
                navigator.sendBeacon(this.product.WishlistTracker);
            }else{
                fetch(this.product.WishlistTracker);
            }
        }
    }

    scrollTracking(product, isSponsored) {
        if(this.$scope.enableCriteoSponsoredAds && product.ViewTracker && this.viewTrackerArray.indexOf(product.ViewTracker) === -1){
            if(!isSponsored) return;
            this.viewTrackerArray.push(product.ViewTracker);
            if(navigator.sendBeacon){
                navigator.sendBeacon(product.ViewTracker);
            }else{
                fetch(product.ViewTracker);
            }

            const placementTracker = this.searchService.getTrackingPlacementData();
            if(placementTracker && placementTracker.ViewTracker && this.productIndex === 0){
                if(navigator.sendBeacon){
                    navigator.sendBeacon(placementTracker.ViewTracker);
                }else{
                    fetch(placementTracker.ViewTracker);
                }
            }
        }
    };
}

module.exports = function ($timeout, $state, moveFocus, settingsService) {
    return {
        restrict: 'E',
        controller: ['TrolleyService', 'SavedListsService', '$rootScope', '$scope', '$stateParams', 'ShopPageStateService', '$uibModal', 'AtmService', 'SettingsService', 'CurrentUserService', 'BwsNotificationService', '$timeout', 'CollectionTimeService', 'StorePickerService', 'BreakpointsService', 'ShopperService', 'SearchService', 'BadgeService', 'InMemoryStorage', ProductController],
        controllerAs: 'ctrl',
        bindToController: {
            product: '=',
            triggerOnWatch: '&?',
            parentTitle: '@?',
            productIndex: '=?',
            lazyLoad: '@?',
            productCollection: '=?',
            crossSellType: '=?'
        },
        scope: {
        },
        link(scope, element) {

            let modalInstance = null;
            let isEnableAppBasedOffers = false;

            scope.savingsAmount = (scope.ctrl.product.PercentageOffTag.TagType !== 'None' || scope.ctrl.product.FixedPricePromoTag.TagType !== 'None')
                ? (scope.ctrl.product.PercentageOffTag.SavedAmount || scope.ctrl.product.FixedPricePromoTag.SavedAmount)
                : scope.ctrl.product.SavingsAmount;

            scope.isSmallFormat = scope.ctrl.breakpointsService.isSmallFormat();

            const currentDateTime = new Date(); // product controller should return server datetime.

            for (const index in scope.ctrl.product.AdditionalDetails) {
                if (scope.ctrl.product.AdditionalDetails[index].Name.toLowerCase() === 'preordermarketreleasedate' &&
                    new Date(scope.ctrl.product.AdditionalDetails[index].Value) > currentDateTime) {
                    scope.preOrderMarketReleaseDate = new Date(scope.ctrl.product.AdditionalDetails[index].Value);
                }
            }

            scope.hideTooltip = function (e) {
                $timeout(function () {
                    $(e.currentTarget).closest('.productTile').find('.tooltip').removeClass('animated fadeInDown is-active');
                }, 5000);
            };

            scope.triggerOnBasketChangeEvent = function(productInfo){
                const type = productInfo.product.AdditionalDetails.find((el)=> el.Name === "productunitquantity");
                const actualQuantity = type.Value * productInfo.product.DisplayQuantity;
                if(scope.enableCriteoSponsoredAds && scope.selectedProduct.product.BasketChangeTracker){
                    const basketChangeTrackerUrl = new URL(scope.selectedProduct.product.BasketChangeTracker);
                    basketChangeTrackerUrl.searchParams.append('quantity', actualQuantity.toString());
                    if(navigator.sendBeacon){
                        navigator.sendBeacon(basketChangeTrackerUrl);
                    }else{
                        fetch(basketChangeTrackerUrl);
                    }
                }
            };

            scope.$on('basketTracker:update', function (e,productInfo) {
                scope.triggerOnBasketChangeEvent(productInfo);
            });

            scope.ctrl.isShowPercentageOffBadge = scope.ctrl.badgeService.showPercentageOffBadge(scope.ctrl.product);

            if (scope.ctrl.product.isProductGroup) {
                scope.productGroupLinkStockCode = scope.ctrl.product.Stockcode;
            }

            settingsService.getSettingValue('BazaarVoice', 'BazaarvoiceApiCallEnabled').then(function (setting) {
                scope.bazaarvoiceCallEnabled = setting || false;
            });

            settingsService.getSettingValue('SponsoredAd', 'EnableCriteoSponsoredAdsWeb').then(function (setting) {
                scope.enableCriteoSponsoredAds = setting || false;
            });

            // feature toggle for Appy Deals
            settingsService
                .getSettingValue('Loyalty', 'EnableAppBasedOffers')
                .then((val) => {
                    isEnableAppBasedOffers = !!val;

                    if (isEnableAppBasedOffers && appyDealsCheck(scope.ctrl.product) && !scope.ctrl.isInRestrictedCategory) {
                        scope.ctrl.showAppyDeals = true;
                    }

                    // remove badge if is AppyDeal but feature toggle off
                    if (!isEnableAppBasedOffers && isAppyDealsBadge(scope.ctrl.productBadge)) {
                        scope.ctrl.productBadge = null;
                    }
                });

            scope.selectedProduct = { product: scope.ctrl.product };
            scope.toggleCheckStockPopup = () => {
                modalInstance = scope.ctrl.$uibModal.open({
                    animation: true,
                    templateUrl: 'stock-nearby',
                    scope,
                    size: 'lg',
                    windowClass: 'modal--stock-nearby'
                });
            };

            scope.closePopup = () => {
                modalInstance.dismiss('cancel');
            };

            scope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.isSmallFormat = scope.ctrl.breakpointsService.isSmallFormat();
                });
            });

            scope.$on('trolley:update', (event, trolley) => {

                if (trolley.type === 'update') {
                    const productInTrolley = _.find(scope.ctrl.productCollection.Products, { Stockcode: trolley.product.Stockcode });

                    if (!_.isUndefined(productInTrolley)) {
                        scope.ctrl.isAddingToTrolley = false;

                        productInTrolley.IsInTrolley = true;

                        scope.ctrl.product = productInTrolley;
                    }
                }


                if ((trolley.type === 'remove' &&
                    ((trolley.product && trolley.product.Stockcode === scope.ctrl.product.Stockcode) || trolley.stockcode === scope.ctrl.product.Stockcode))
                    || trolley.type === 'clear') {

                    scope.ctrl.product.IsInTrolley = false;

                    scope.ctrl.product.QuantityInTrolley = 0;
                }
            });

            scope.$on('productFamily:cartUpdated', function (e, data) {
                scope.ctrl.product = data.product;
                scope.ctrl.product.IsInTrolley = true;

                // refresh showPercentageOffBadge flag
                scope.ctrl.isShowPercentageOffBadge = scope.ctrl.badgeService.showPercentageOffBadge(scope.ctrl.product);

                // refresh scope.ctrl.showAppyDeals flag
                if (isEnableAppBasedOffers) {
                    scope.ctrl.showAppyDeals = !scope.ctrl.isInRestrictedCategory
                        ? appyDealsCheck(scope.product)
                        : false;
                }
                // remove badge if is AppyDeal but feature toggle off
                scope.ctrl.productBadge = (!scope.ctrl.showAppyDeals && isAppyDealsBadge(scope.ctrl.productBadge))
                    ? null
                    : scope.ctrl.product.Tags[0];
            });

            // if the previous state was product detail
            // and for the same product than this card
            // then move focus to this card

            if ($state.previous.route.name === 'shop.productdetails'
                && $state.previous.routeParams.productId === scope.ctrl.product.ProductData.parentstockcode) {
                moveFocus(element);
            }
        },
        template: require('./bws-product-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shelfproduct/bws-product-directive.js
 **/